// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDJJz3UCcitg6P1UL2SBDkizKJRZ_Z6umg",
    authDomain: "keepspot-84370.firebaseapp.com",
    projectId: "keepspot-84370",
    storageBucket: "keepspot-84370.firebasestorage.app",
    messagingSenderId: "872851386403",
    appId: "1:872851386403:web:9d1e90903c7f9c6f084196"
};

// Initialize Firebase
// avoid re-initializing if hot-reloading or multi-imports
const app = !getApps().length
    ? initializeApp(firebaseConfig)
    : getApps()[0];

export const firebaseApp = app;
export const firebaseAuth = getAuth(app);
export const firestoreDb = getFirestore(app);
